import * as yup from 'yup';
import { SuggestionSchema } from '../../../common';
import { RiskAssessmentSchema } from '../../../common/IRiskAssessment';
import { ScaleRatingSchema, ScaleRatingSuggestionSchema } from '../../../common/IScaleRating';

export const FallRiskFormSchema = yup.object({
  maintainSittingPosition: ScaleRatingSchema,
  assumeDifferentSittingPosition: ScaleRatingSchema,
  climbStairs: ScaleRatingSchema,
  standWalkKeepBalance: ScaleRatingSchema,
  moveAroundLivingArea: ScaleRatingSchema,
  legBodyStrength: ScaleRatingSchema,
  aidsUsage: ScaleRatingSchema,
  stabilityAfterMedication: ScaleRatingSchema,
  riskAssessment: RiskAssessmentSchema,
});
export type IFallRiskForm = yup.InferType<typeof FallRiskFormSchema>;

export const FallRiskSuggestionSchema = yup.object({
  maintainSittingPosition: ScaleRatingSuggestionSchema.nullable(),
  assumeDifferentSittingPosition: ScaleRatingSuggestionSchema.nullable(),
  climbStairs: ScaleRatingSuggestionSchema.nullable(),
  standWalkKeepBalance: ScaleRatingSuggestionSchema.nullable(),
  moveAroundLivingArea: ScaleRatingSuggestionSchema.nullable(),
  legBodyStrength: ScaleRatingSuggestionSchema.nullable(),
  aidsUsage: ScaleRatingSuggestionSchema.nullable(),
  stabilityAfterMedication: ScaleRatingSuggestionSchema.nullable(),
  noFallRiskDueTo: SuggestionSchema.nullable(),
  fallRiskDueTo: SuggestionSchema.nullable(),
});

export type IFallRiskSuggestion = yup.InferType<typeof FallRiskSuggestionSchema>;

// Validation Schema for Creating a FallRiskForm
export const CreateFallRiskFormSchema = yup
  .object({
    residentId: yup.string().required(),
  })
  .concat(FallRiskFormSchema);
export type ICreateFallRiskForm = yup.InferType<typeof CreateFallRiskFormSchema>;

// Validation Schema for Updating a FallRiskForm
export const UpdateFallRiskFormSchema = yup
  .object({
    id: yup.string().required(),
  })
  .concat(FallRiskFormSchema);
export type IUpdateFallRiskForm = yup.InferType<typeof UpdateFallRiskFormSchema>;
